// normalize CSS across browsers
import './static/styles/normalize.css';
// custom CSS styles
import './static/styles/layout.css';
import { ShopifyProvider, CartProvider } from '@shopify/hydrogen-react';
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
const React = require(`react`);

export const wrapRootElement = ({ element }) => {
  return (
    <ShopifyProvider
      storeDomain={process.env.GATSBY_SHOPIFY_PUBLIC_STORE_DOMAIN || ``}
      storefrontToken={
        process.env.GATSBY_SHOPIFY_PUBLIC_STOREFRONT_API_TOKEN || ``
      }
      storefrontApiVersion={
        process.env.GATSBY_SHOPIFY_STOREFRONT_API_VERSION || `2025-01`
      }
      countryIsoCode="US"
      languageIsoCode="EN"
    >
      <CartProvider>{element}</CartProvider>
    </ShopifyProvider>
  );
};
